module.exports = __webpack_public_path__ + "img/ethereumBadge.a33d667a.svg";